/**
 * Markalama (logo/favicon) değişikliğini panelin geri kalanına duyurur.
 *
 * Sol menüdeki logo Header içinde bir kez çekilip `blob:` URL'i olarak state'te
 * tutuluyor. Logo başka bir ekranda yüklenip silindiğinde Header'ın bundan haberi
 * olmadığı için eski görsel ekranda kalıyordu — ancak sekme kapatılıp açılınca
 * (yeni mount → yeni istek) düzeliyordu.
 *
 * Redux'a bağlamak yerine pencere olayı seçildi: markalama tek yönlü ve nadir bir
 * sinyal, abonesi de tek bir bileşen.
 */
export const BRANDING_UPDATED_EVENT = "company-branding-updated";

export const notifyBrandingUpdated = () => {
    window.dispatchEvent(new Event(BRANDING_UPDATED_EVENT));
};
